import AxiosInstance from './AxiosInstance';

export const canDownloadBooks = (user) => {
  if (!user) return false;
  if (user.student?.canDownloadBooks === true) return true;
  if ((user.email || '').toLowerCase() === 'amc@mdn.dz') return true;
  if (user.bac_matricule === '0000000012') return true;
  return false;
};

const safeFilename = (title, bookId) => {
  const base = String(title || bookId || 'livre')
    .replace(/[<>:"/\\|?*\u0000-\u001f]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 80);
  return `${base || bookId}.pdf`;
};

export const downloadBookPdf = async (bookId, title) => {
  const data = await AxiosInstance.get(`/pdf/${bookId}`, {
    params: { download: 1 },
    responseType: 'blob',
  });
  const blob = data instanceof Blob ? data : new Blob([data], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = safeFilename(title, bookId);
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
